import utils from '@/mixins/utils'

/**
 * Filtra os dados
 *
 * @param {Array} cadastros
 * @param {Boolean} exibirVermelhos
 * @param {Boolean} exibirVerdes
 * @param {Object} selectedEstabelecimento
 * @returns {Array}
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedEstabelecimento
) {
  let cadastrosFiltrados = cadastros

  if (exibirVermelhos === true) {
    cadastrosFiltrados = cadastrosFiltrados.filter((item) => {
      if (Number(item.qtd_atends_us_selecionada_7dias) >= 2) {
        return true
      }
    })
  }

  if (exibirVerdes === true) {
    cadastrosFiltrados = cadastrosFiltrados.filter((item) => {
      if (Number(item.qtd_atends_us_selecionada_7dias) < 2) {
        return true
      }
    })
  }

  return cadastrosFiltrados.map((item, index) => {
    let nu_cpf = ''
    let nu_cns = ''
    let nu_cnes = ''
    let no_unidade_saude = ''

    if (item.cfcp != null) {
      if (item.cfcp.length == 11) {
        nu_cpf = item.cfcp
      } else {
        nu_cns = item.cfcp
      }
    }

    if (selectedEstabelecimento != null) {
      nu_cnes = selectedEstabelecimento.no_unidade_saude.split(' ')[0]
      no_unidade_saude = selectedEstabelecimento.no_unidade_saude
    }

    const color =
      Number(item.qtd_atends_us_selecionada_7dias) >= 2 ? 'red' : 'green'

    return {
      id: index,
      ...item,
      nu_cpf,
      nu_cns,
      nu_cnes,
      no_unidade_saude,
      color,
    }
  })
}
